export default __webpack_public_path__ + "static/media/truck-ok.09c3f1d2.svg";